import { Button } from '@timelyapp/react';
import { Close } from 'components/Icons';
import {
  HAS_SEEN_PEOPLE_INTEGRATIONS_MESSAGE,
  HAS_SEEN_PROJECTS_INTEGRATIONS_MESSAGE,
} from 'constants/user';
import jira from 'images/apps_logo/jira.svg';
import toggl from 'images/apps_logo/toggl.svg';
import React from 'react';
import { connect } from 'react-redux';
import { toggleAppsListModal } from 'redux/modules/apps.actions';
import type { IntegrationTypesStrings } from 'redux/modules/integrations.types';
import { INTEGRATIONS_IS_ENABLED, IntegrationTypes } from 'redux/modules/integrations.types';
import { saveUserProperty } from 'redux/modules/user.actions';
import type { UserProperties } from 'redux/modules/user.types';
import { getUserProperties } from 'redux/selectors/user';
import type { IState } from 'redux/state';
import type { MappedActions } from 'types/redux';
import styles from './AppImportsCTA.module.scss';

const mapActionsToProps = {
  toggleAppsListModal,
  saveUserProperty,
};

const mapStateToProps = (state: IState) => ({
  properties: getUserProperties(state),
});

type ActionProps = MappedActions<typeof mapActionsToProps>;

type Props = {
  type: IntegrationTypesStrings;
  properties: UserProperties;
  style?: React.CSSProperties;
} & ActionProps;

const AppImportsCTA: React.FC<Props> = ({ type, properties, style, ...props }) => {
  const userProperty =
    type === IntegrationTypes.PEOPLE
      ? HAS_SEEN_PEOPLE_INTEGRATIONS_MESSAGE
      : HAS_SEEN_PROJECTS_INTEGRATIONS_MESSAGE;

  if (!INTEGRATIONS_IS_ENABLED || properties[userProperty]) {
    return null;
  }

  return (
    <article style={style} className={styles.container}>
      <div className={styles.imgWrap}>
        <img src={toggl} alt="Toggl" />
        <img src={jira} alt="Jira" />
      </div>
      <h1>Import {type.toLowerCase()} from Toggl and Jira to save time!</h1>
      <div className={styles.actionsWrap}>
        <Button onClick={props.toggleAppsListModal}>Go to apps</Button>
        <Button
          onClick={() => props.saveUserProperty(userProperty, true)}
          className={styles.plainButton}
          priority="low"
        >
          <Close />
        </Button>
      </div>
    </article>
  );
};

export default connect(mapStateToProps, mapActionsToProps)(AppImportsCTA);
